import checkoutActions from "./actions";

const initialState = {
  deliveryType: [],
  paymentType: [],
  // shippingProvidersType: [],
  checkoutValues: {},
  orderSuccessModal: {
    isOpen: false,
    status: null,
  },
  htmlPayload: null,
  decoderResponse: null,
  phonepeEncodedData: null,
  initialPayment: null,
};

const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case checkoutActions.SET_DELIVERY_TYPE_LIST:
      return {
        ...state,
        deliveryType: action.payload,
      };
    case checkoutActions.CHECKOUT_VALUES:
      return {
        ...state,
        checkoutValues: action.payload,
      };
    case checkoutActions.SET_PAYMENT_TYPE_LIST:
      return {
        ...state,
        paymentType: action.payload,
      };
    // case checkoutActions.SET_SHIPPING_PROVIDERS:
    //   return {
    //     ...state,
    //     shippingProvidersType: action.payload,
    //   };
    case checkoutActions.SHOW_ORDER_SUCCESS_MODAL:
      return {
        ...state,
        orderSuccessModal: action.payload,
      };
    case checkoutActions.INITIATE_CCAVENUE_TRANSACTION_SUCCESS:
      return {
        ...state,
        htmlPayload: action.payload,
      };
    case checkoutActions.DECODER_RESPONSE:
      return {
        ...state,
        decoderResponse: action.payload,
      };
    case checkoutActions.SET_PHONEPE_ENCODED_DATA:
      return {
        ...state,
        phonepeEncodedData: action.payload,
      };
    case checkoutActions.GET_INITIAL_PAYMENT_TYPE:
      return {
        ...state,
        initialPayment: action.payload,
      };

    default:
      return state;
  }
};

export default checkoutReducer;
